import { SimulatorWrapper as SimulatorWrapperV2 } from "./context/SimulatorWrapper";
import { Simulator as SimulatorV2 } from "./Simulator";

export const SimulatorDistinctVersions = (
  props: {
    simulatorId?: string;
  } & any
) => {

  return (
    <SimulatorWrapperV2 simulatorId={props.simulatorId}>
      <SimulatorV2 {...props} />
    </SimulatorWrapperV2>
  )
};
